import { Controller } from "@hotwired/stimulus"
import {
  Chart, BarController, BarElement, LineController, LineElement, PointElement,
  CategoryScale, LinearScale, Tooltip, Legend
} from "chart.js"

// Narrow registration, not `chart.js/auto`: two chart types do not justify
// bundling every controller, scale and plugin into an app-wide bundle.
Chart.register(BarController, BarElement, LineController, LineElement, PointElement,
  CategoryScale, LinearScale, Tooltip, Legend)

// Renders a Chart.js chart from a server-built config. The whole config is
// assembled in Ruby and passed as JSON, so a new chart is added by writing ERB
// rather than JS.
//
// The config cannot carry functions — JSON has none. Anything Chart.js wants as
// a callback (tick formatters, tooltip labels) has to be applied here instead of
// passed through. Money formatting is the live case: a config sets
// `moneyAxis: true` and this attaches the vi-VN formatters.
export default class extends Controller {
  static values = { config: Object }

  connect() {
    this.chart = new Chart(this.element, this.#withFormatters(this.configValue))
  }

  // Turbo caches pages and restores them from that cache. Without this the
  // cached canvas keeps a live Chart bound to a detached element, and the next
  // visit throws "Canvas is already in use".
  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }

  // Re-attaches the callbacks that could not survive to_json.
  #withFormatters(config) {
    if (!config.moneyAxis) return config

    const format = (value) => new Intl.NumberFormat("vi-VN").format(value)

    config.options ||= {}
    config.options.scales ||= {}
    config.options.scales.y ||= {}
    config.options.scales.y.ticks ||= {}
    config.options.scales.y.ticks.callback = format

    config.options.plugins ||= {}
    config.options.plugins.tooltip ||= {}
    config.options.plugins.tooltip.callbacks = {
      label: (ctx) => `${ctx.dataset.label}: ${format(ctx.parsed.y)} ₫`
    }
    return config
  }
}
